import * as React from 'react'

function SvgDocumentIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.275 6.975l-5.25-5.25A.68.68 0 0013.5 1.5H6A1.505 1.505 0 004.5 3v18A1.504 1.504 0 006 22.5h12a1.504 1.504 0 001.5-1.5V7.5a.682.682 0 00-.225-.525zM13.5 3.3l4.2 4.2h-4.2V3.3zM18 21H6V3h6v4.5A1.504 1.504 0 0013.5 9H18v12z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgDocumentIcon
